import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEuro = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_3560_20629",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_3560_20629)",
		children: /* @__PURE__ */ _jsx("path", { d: "M15.0192 20.5C13.0717 20.5 11.3714 19.9528 9.91823 18.8586C8.46503 17.7644 7.44741 16.3628 6.86536 14.6538H3.36536V13.1538H6.54038C6.47757 12.7602 6.45032 12.3542 6.45866 11.9356C6.46699 11.517 6.49423 11.1538 6.54038 10.8461H3.36536V9.34615H6.88461C7.46024 7.63718 8.47306 6.23558 9.92306 5.14135C11.373 4.04712 13.0717 3.5 15.0192 3.5C16.0923 3.5 17.1076 3.68333 18.0653 4.05C19.023 4.41667 19.8826 4.92308 20.6442 5.56923L19.575 6.61343C18.9519 6.10574 18.2544 5.70991 17.4827 5.42593C16.7109 5.14196 15.8897 4.99998 15.0192 4.99998C13.4807 4.99998 12.1419 5.41088 11.0028 6.23268C9.86373 7.05448 9.03007 8.0923 8.50186 9.34615H14.9615V10.8461H8.06533C7.99226 11.2705 7.96086 11.6936 7.97111 12.1154C7.98136 12.5372 8.01276 12.8833 8.06533 13.1538H14.9615V14.6538H8.49226C9.02687 15.9077 9.86373 16.9455 11.0028 17.7673C12.1419 18.5891 13.4807 19 15.0192 19C15.8897 19 16.7109 18.858 17.4827 18.574C18.2544 18.29 18.9519 17.8942 19.575 17.3865L20.6442 18.4307C19.8826 19.0769 19.023 19.5833 18.0653 19.95C17.1076 20.3166 16.0923 20.5 15.0192 20.5Z" })
	})]
});
export default SvgEuro;
